import React, { useState } from 'react';
import {
  Link,
  useRouter,
} from '@tanstack/react-router';

import {
  APIacceptTimelineContributor,
  APIdeclineTimelineContributor,
} from '../../api/Timeline';

import type { Timeline } from '../../types/timeline';

const TimelineContributorInvite: React.FC<{ timeline: Timeline  }> = ({ timeline }) => {
  const [error, setError] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);

  const router = useRouter();

  const acceptInvitation = async () => {
    if (!timeline.contributor) return;

    setError(null);
    setSaving(true);
    try {
      await APIacceptTimelineContributor(timeline.id, timeline.contributor.id);
    } catch (error) {
      console.error('Error accepting invitation:', error);
      setError((error as Error).message || 'An error occurred while accepting the invitation.');
    } finally {
      router.invalidate();
    }
  };

  const declineInvitation = async () => {
    if (!timeline.contributor) return;

    setError(null);
    setSaving(true);
    try {
      await APIdeclineTimelineContributor(timeline.id, timeline.contributor.id);
    } catch (error) {
      console.error('Error declining invitation:', error);
      setError((error as Error).message || 'An error occurred while declining the invitation.');
    } finally {
      router.invalidate();
    }
  };

  return (
    <div className="timeline-view-contributor-notice">
      {error && (
        <wa-callout variant="danger">
          {error}
        </wa-callout>
      )}
      <wa-callout variant="warning">
        <i className="fa-regular fa-user-plus" slot="icon"></i>
        <div className="wa-cluster wa-gap-2xs timeline-view-contributor-notice-content">
          <div>
            <strong>You have a pending contributor invitation to this timeline</strong><br />
            Go to <Link to="/dashboard/invitations">your invitations</Link> to view all your pending invitations.
          </div>
          <div className="wa-cluster wa-gap-2xs">
            <wa-button size="small" onClick={acceptInvitation} disabled={saving}>
              Accept
            </wa-button>
            <wa-button size="small" onClick={declineInvitation} disabled={saving}>
              Decline
            </wa-button>
          </div>
        </div>
      </wa-callout>
    </div>
  );
}

export default TimelineContributorInvite;
